import React from "react";

export default function withProps(Component, props) {
  return () => <Component {...props} />;
}
